<div class="modal">
  <div class="modal__child">
    <app-icon [icon]="Icon.RoundWarning" class="modal__image" [color]="Color.LightRed"></app-icon>
    <app-title class="modal__message" size="h1" kind="4">
      <ng-content></ng-content>
    </app-title>
  </div>
  <button class="modal__button" type="button" autofocus (click)="closeModal()">
    Ok
  </button>
</div>
